import React from 'react';
import Container from 'components/layout/Container';
import RequestForm from 'components/ui/RequestForm';
import {Title, TitleSize, TitleLevel} from 'components/ui/Title';

import './OrderSection.scss';

const OrderSection = ({innerRef, background = 'light'}) => {
  return (
    <section
      ref={innerRef}
      id="form"
      className={`order-section order-section_${background}-bg`}
    >
      <Container className="order-section__wrapper">
        <Title
          extraClassName="order-section__title"
          level={TitleLevel.H2}
          size={TitleSize.H2}
        >
          Отправьте заявку
        </Title>

        <RequestForm showTariffInput showCommentInput background={background} />
      </Container>
    </section>
  );
};

export default OrderSection;
